export default {"src":"/_next/static/media/google.27493432.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};